module.exports = __webpack_public_path__ + "img/pdf.939449c6.png";